import React from "react";
import PageHeader from "../components/PageHeader";
import PublicPageSettings from "../components/PublicPageSettings";
import BuildingsManager from "../components/BuildingsManager";

export default function OfficesHome() {
  return (
    <div>
      <PageHeader
        title="Offices"
        subtitle="Edit page settings and browse office buildings. Click any building to edit its SEO, description, and primary photo."
      />

      <PublicPageSettings
        collectionKey="offices"
        publicPath="/offices"
        defaultHeading="Office Spaces for Lease"
        defaultSubheading="Search for office spaces for lease across all major cities and business districts in the Philippines. Let us guide you to your next office space."
      />

      <BuildingsManager />
    </div>
  );
}
